import { useState } from "react";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import api from "../../services/api";
import { setAllCohorts } from "../../features/cohort/cohortSlice";

export default function CohortsApproval() {
  const dispatch = useDispatch();
  const allCohorts = useSelector(state => state.cohort.all);
  const [search, setSearch] = useState("");


  const previewed = allCohorts.filter(
    c => c.status === "PREVIEWED"
  );
  const filtered = previewed.filter(c =>
    c.cohort_name
      .toLowerCase()
      .includes(search.toLowerCase())
  );


  const approve = async (cohort) => {
    try {
      await api.post(
        `https://aihealth.ascendeongroup.com/api-dev/v1/admin/cohorts/${cohort.segment_id}/approve`,
        null,
        { headers: { accept: "application/json" } }
      );

      const updated = allCohorts.map(c =>
        c.segment_id === cohort.segment_id
          ? { ...c, status: "APPROVED" }
          : c
      );

      dispatch(setAllCohorts(updated));

    } catch (err) {
      console.error("Approve failed", err);
    }
  };

  const columns = [
    {
      name: "Cohort Name",
      selector: row => row.cohort_name,
      sortable: true,
      grow: 2
    },
    {
      name: "Status",
      selector: row => row.status,
      cell: row => (
        <span className="admin-status previewed">
          {row.status}
        </span>
      )
    },
    {
      name: "Action",
      cell: row => (
        <button
          className="admin-btn primary"
          onClick={() => approve(row)}
        >
          Approve
        </button>
      )
    }
  ];

  return (
    <div className="admin-page">
      <h2>Cohorts Approval</h2>

      <DataTable
        columns={columns}
        data={filtered}
        pagination
        fixedHeader
        fixedHeaderScrollHeight="65vh"
        highlightOnHover
        responsive
        subHeader
        subHeaderComponent={
          <input
            placeholder="Search cohort..."
            className="datatable-search"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        }

      />
    </div>
  );
}
